import React from 'react';

import { CheckCircleFilledIcon, CrossCircleFilledIcon } from '@vlabs/icons';
import { Tag } from '@vlabs/uikit';

export type TResultStatus = 'real' | 'fake' | 'spoof' | 'unknown';

interface CheckTagProps {
  kind: TResultStatus;
  value: string;
}

const tagIconMap: Record<TResultStatus, React.ReactNode> = {
  real: <CheckCircleFilledIcon />,
  fake: <CrossCircleFilledIcon />,
  spoof: <CrossCircleFilledIcon />,
  unknown: <CrossCircleFilledIcon />,
};

const tagKindMap: Record<TResultStatus, string> = {
  real: 'positive',
  fake: 'negative',
  spoof: 'negative',
  unknown: 'secondary',
};

function CheckTag({
  kind,
  value,
}: CheckTagProps): React.JSX.Element {
  return (
    <Tag
      icon={tagIconMap[kind]}
      kind={tagKindMap[kind]}
      shape="square"
      size="large"
      value={value}
    />
  );
}

export { CheckTag };
